/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const Animations = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.steps();
		jQuery('body').on('update_checkout', function() {
			const selectedValues = $('select').val();
			if (selectedValues && selectedValues !== null && selectedValues.length > 0) {
				$('#shipping_state_field label').addClass('is-moved');
				$('#billing_country label').addClass('is-moved');
				$('#billing_state_field label').addClass('is-moved');
				$('#shipping_country_field label').addClass('is-moved');
			} else {
				$('#shipping_state_field label').removeClass('is-moved');
				$('#billing_country label').removeClass('is-moved');
				$('#billing_state_field label').removeClass('is-moved');
				$('#shipping_country_field label').removeClass('is-moved');
			}
			if($('#billing_state_field input').val()) {
				$('#billing_state_field label').addClass('is-moved');
			} else {
				$('#billing_state_field label').removeClass('is-moved');
			}
			if($('#shipping_state_field input').val()) {
				$('#shipping_state_field label').addClass('is-moved');
			} else {
				$('#shipping_state_field').removeClass('is-moved');
			}
		});
	},

	/** @description Bind Events */
	steps: function() {
		$('.steps-block__box').each(function() {
			const puzzle = $(this);
			const scroll_position = puzzle.offset().top - 700;
			const screen_height = $(window).height();
			const activation_offset = 0;
			const max_scroll_height = $('body').height() + screen_height;
			const scroll_activation_point = scroll_position - (screen_height * activation_offset);

			$(window).on('scroll', function(e) {
				const y_scroll_pos = window.pageYOffset;
				const element_in_view = y_scroll_pos > scroll_activation_point;
				const has_reached_bottom_of_page = max_scroll_height <= y_scroll_pos && !element_in_view;

				if (element_in_view || has_reached_bottom_of_page) {
					puzzle.addClass('change');
				} else {
					puzzle.removeClass('change');
				}
			});
		});
		if(window.innerWidth < 1186) {
			$('.steps-block__box').each(function() {
				const puzzle = $(this);
				const scroll_position = puzzle.offset().top - 600;
			});
		}

		if(window.innerWidth < 978) {
			$('.steps-block__box').each(function() {
				const puzzle = $(this);
				const scroll_position = puzzle.offset().top - 400;
			});
		}
	},
};

export default Animations;